module.exports = (__webpack_require__(12))(39);


//////////////////
// WEBPACK FOOTER
// delegated ./plugins/large_image/web_client/annotations/geometry/rectangle.js from dll-reference girder_plugin_large_image
// module id = 131
// module chunks = 0